import $ from "jquery"
import "jquery-match-height";

$('.js-match-height-flow-items').matchHeight();
$('.js-solution-matchheight-boxes').matchHeight();
$('.js-challenges-matchheight').matchHeight();
$('.js-simple-template-matchheight').matchHeight();
$('.js-numeric-grid-matchheight').matchHeight();
$('.js-systems-matchheight').matchHeight();

$(window).on('load', function(){
    $('.js-match-height-flow-items').matchHeight();
    $('.js-solution-matchheight-boxes').matchHeight();
    $('.js-challenges-matchheight').matchHeight();
    $('.js-simple-template-matchheight').matchHeight();
    $('.js-numeric-grid-matchheight').matchHeight();
    $('.js-systems-matchheight').matchHeight();
});

$(window).on('resize', function(){
    setTimeout(function(){
        $('.js-match-height-flow-items').matchHeight();
        $('.js-solution-matchheight-boxes').matchHeight();
        $('.js-challenges-matchheight').matchHeight();
        $('.js-simple-template-matchheight').matchHeight();
        $('.js-numeric-grid-matchheight').matchHeight();
        $('.js-systems-matchheight').matchHeight();
    }, 500);
});